import { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { EPaymentStatus } from '../types/reducers/depositAccount';

import { updateDepositAccountRecommendedPackagePaymentStatus } from '../actions/depositAccount';
import { checkPaymentStatus } from '../thunks/payment/checkPaymentStatus';

import { selectRecommendedPackagePaymentStatus } from '../selectors/depositAccount';

let failTimeout: number;
let checkInterval: number;

const clearTimers = () => {
  clearInterval(checkInterval);
  clearTimeout(failTimeout);
};

export const useCheckPaymentQueue = () => {
  const dispatch = useDispatch();

  const paymentStatus = useSelector(selectRecommendedPackagePaymentStatus);

  const runCheckPaymentQueue = useCallback(() => {
    clearTimers();

    dispatch(updateDepositAccountRecommendedPackagePaymentStatus(EPaymentStatus.Pending));

    checkInterval = window.setInterval(() => dispatch(checkPaymentStatus()), 3000);

    failTimeout = window.setTimeout(() => {
      dispatch(updateDepositAccountRecommendedPackagePaymentStatus(EPaymentStatus.Fail));

      clearTimers();
    }, 300000); // 5 минут

    dispatch(checkPaymentStatus());
  }, [dispatch]);

  useEffect(() => {
    if (paymentStatus && paymentStatus !== EPaymentStatus.Pending) {
      clearTimers();
    }
  }, [paymentStatus]);

  return { runCheckPaymentQueue };
};
